import { membershipsSlice } from './slice';

export const {
  setLoading,
  setLoaded,
  setLoadedSeveral,
  add,
  remove,
  addProjectPlaceholder,
  updateProjectPlaceholder,
  removeProjectPlaceholder,
} = membershipsSlice.actions;
